import Plyr from 'plyr';
import 'plyr/dist/plyr.css';


export function initVideoPlayer (video) {
  // Embed block wraps an <iframe> in .plyr__video-embed; the video block
  // renders a native <video>. Plyr takes either as its target.
  const embed = video.querySelector('.plyr__video-embed');
  const target = embed || video.querySelector('video');

  if (!target) return;

  const player = new Plyr(target, {
    controls: [
      'play-large',
      'play',
      'progress',
      'current-time',
      'mute',
      'fullscreen'
    ],
    autoplay: false,
    // Embeds start muted (autoplay policy); a native video keeps its sound.
    muted: Boolean(embed),
    loop: { active: false },
  });
}

document.querySelectorAll('[data-video]').forEach(video => initVideoPlayer(video));

